<template>
  <div>
    <div v-show="mapInitDone" class="map-controls-container">
      <i class="material-icons md-24 help-icon" id="gmapsHelpIcon">help</i>
      <b-tooltip
        target="gmapsHelpIcon"
        boundary="viewport"
        triggers="click"
        placement="bottomleft"
        :delay="globals.tooltipDelay"
      >
        <div class="tooltip-div">
          <img 
            :src="iconMarkerFactory('check').url" 
            height="42" 
            width="24" 
            style="margin-right:4px"
          />
          &rarr; {{lang.SAGM01}}
        </div>
        <div class="tooltip-div">
          <img
            :src="iconMarkerFactory('Open').url"
            height="42" 
            width="24" 
            style="margin-right:4px"
          />
          &rarr; {{lang.SAGM02}}
        </div>
        <div class="tooltip-div">
          <img
            :src="iconMarkerFactory('Approved').url"
            height="42" 
            width="24" 
            style="margin-right:4px"
          />
          &rarr; {{lang.SAGM03}}
        </div>
        <div class="tooltip-div">
          <img
            :src="iconMarkerFactory('Rejected').url"
            height="42" 
            width="24" 
            style="margin-right:4px"
          />
          &rarr; {{lang.SAGM04}}
        </div>
        <div class="tooltip-div">
          <img
            :src="iconMarkerFactory('Multiple').url"
            height="42" 
            width="24" 
            opacity="0.5"
            style="margin-right:4px"
          />
          &rarr; <span style="padding-left:4px" v-html="lang.SAGM05"></span>
        </div>
      </b-tooltip>
    </div>
    <div id="gmaps-container"></div>
  </div>
</template>

<script>
export default {
  name: "GoogleMaps",
  props: {
    currentFilterObject: {
      Type: Object,
      default: () => ({}),
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    proposalList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      geocoder: null,
      map: null,
      mapInitDone: false,
      location: "Deutschland",
      currentPosition: null,
      icons: {
        check: { icon: "blue_pin.png" },
        Open: { icon: "yellow_pin.png" },
        Approved: { icon: "green_pin.png" },
        Rejected: { icon: "red_pin.png" },
        Multiple: { icon: "rainbow_pin.png" },
      },
      mapOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: true,
        maxZoom: 15,
        minZoom: 3,
        scaleControl: true,
        rotateControl: false,
        disableDefaultUi: false,
        mapTypeId: "roadmap",
        restriction: {
          latLngBounds: {
            north: 80,
            south: -80,
            east: 200,
            west: -200,
          },
        },
      },
      checkMarkers: [],
      shopperMarkers: [],
      currentMapCircle: null,
      selectedMarker: null,
      searchBox: null,
      lang: {
        RCM000: "Search",
        RCM001: "Radius in km",
        RCM002: "Switch radius visibility",
        RCM003: "Filter for this check",
        RCM004: "Filter for this shopper",
        RCM005: "Wave",
        RCM006: "Gender",
        RCM007: "Age",
        RCM008: "male",
        RCM009: "female",
        RCM010: "Shopper",
        RCM011: "Check assigned but not yet edited",
        RCM012: "Check assigned and edited",
        RCM013: "Check not assigned",
        RCM014: "Remove filter",
        RCM015: "Scenario",
        RCM016: "Vehicle",
        RCM017: "Target model",
        RCM018: "Approved shopper",

        SAM005: "ShopperID",
        SAM009: "Distance",
        SAM012: "Segment",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",
        
        A0032: "Approval",

        SAGM01: "Check",
        SAGM02: "Open approval",
        SAGM03: "Completed approval",
        SAGM04: "Rejected approval",
        SAGM05: "Multiple shoppers with <br>same Location",
        SAGM06: "completed"
      },
    };
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (!window.google) {
      this.globals.$once("googleInitDone", () => {
        this.initGoogleMap();
      });
    } else {
      this.initGoogleMap();
    }
    setTimeout(() => {
      this.showChecksOnMap();
      this.showShoppersOnMap();
    }, 500);
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
    isMapRadiusVisible(newVal) {
      if (newVal) $(".btn-marker-info").removeClass("hidden");
      else {
        let button = $(".btn-marker-info");
        button.addClass("hidden");
        button.removeClass("btn-warning");
        button.html(this.lang.RCM003);
      }
    },
  },
  methods: {
    setMarkerOpacity(surveyInstanceId) {
      this.checkMarkers.forEach(e => {
        if(surveyInstanceId == null) {
          e.setOpacity(1);
          return;
        }
        else if(e.SurveyInstanceId != surveyInstanceId) {
          e.setOpacity(0.5);
        } else {
          e.setOpacity(1);
        }
      });
      this.shopperMarkers.forEach(e => {
        if(surveyInstanceId == null) {
          e.setOpacity(1);
          return;
        }
        else if(e.SurveyInstanceId != surveyInstanceId) {
          e.setOpacity(0.5);
        } else {
          e.setOpacity(1);
        }

        if(e.SurveyInstanceIds) {
          let opacity = 0.5;
            if(e.SurveyInstanceIds.includes(surveyInstanceId)) {
              opacity = 1;
            }
          e.setOpacity(opacity);
        }
      })
    },
    setMarkerOpacityViaArray(surveyInstanceIds) {
      this.checkMarkers.forEach(e => {
        if(surveyInstanceIds.includes(e.SurveyInstanceId)) {
          e.setOpacity(1);
        } else {
          e.setOpacity(0.5);
        }
      });
      this.shopperMarkers.forEach(e => {
        if(surveyInstanceIds.includes(e.SurveyInstanceId)) {
          e.setOpacity(1);
        } else {
          e.setOpacity(0.5);
        }
        if(e.SurveyInstanceIds) {
          let opacity = 0.5;
          e.SurveyInstanceIds.forEach(sid => {
            if(surveyInstanceIds.includes(sid)) {
              opacity = 1;
            }
          });
          e.setOpacity(opacity);
        }
      })
    },
    initGoogleMap() {
      let currentPosition = { lat: 51, lng: 10.5 };

      const init = () => {
        this.mapOptions.center = new google.maps.LatLng(
          currentPosition.lat,
          currentPosition.lng
        );
        this.mapOptions.zoom = 6;

        this.map = new google.maps.Map(
          document.getElementById("gmaps-container"),
          this.mapOptions
        );
        this.map.infowindow = new google.maps.InfoWindow();

        this.geocoder = new google.maps.Geocoder();

        google.maps.event.addListenerOnce(this.map, "tilesloaded", () => {
          this.mapInitDone = true;
        });
        this.map.addListener("click", () => {
          this.setMarkerOpacity(null);
        });
      };

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          currentPosition = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          init();
        },
        (error) => {
          console.error(error);
          init();
        }
      );
    },
    iconMarkerFactory(type = "Open", size = { width: 24, height: 42 }) {
      const iconBaseUrl = "/static/pins/";
      let url = `${iconBaseUrl}${this.icons[type].icon}`;
      let scaledSize = size;
      return { url, scaledSize };
    },
    zoomToLocation(formatted_address) {
      this.geocoder.geocode(
        { address: formatted_address },
        (results, status) => {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          this.map.setCenter(results[0].geometry.location);
          this.map.fitBounds(results[0].geometry.viewport);
        }
      );
    },
    showChecksOnMap() {
      this.clearCheckMarkers();

      this.checkList.forEach((check) => {
        if (!check.Location) return;
        let location = {
          lng: check.Location.Longitude,
          lat: check.Location.Latitude,
        };

        let infotext = `<div style="text-align: left;">
          <b>Check ID: ${check.SurveyInstanceId}</b>
          <br>
          <br>${check.LocationName}
          <br>
          <br>${check.LocationAddress}
          <br>
          <br>${this.lang.RCM005}: ${check.WaveName}
          <br>${this.lang.RCM015}: ${check.ScenarioName}`;

        if (check.ApprovedShopperName)
          infotext += `<br>
          <br>${this.lang.RCM018}:
          <br>${check.ApprovedShopperName}`;

        infotext += `</div>`;

        const customIcon = this.iconMarkerFactory("check");

        const marker = new google.maps.Marker({
          position: location,
          map: this.map,
          icon: customIcon,
          infotext: infotext,
        });
        marker.addListener("click", () => {
          this.showMarkerInfo(marker);
          this.selectedMarker = marker;
          this.setMarkerOpacity(marker.SurveyInstanceId);
        });
        marker.SurveyInstanceId = check.SurveyInstanceId;
        this.checkMarkers.push(marker);
      });
    },
    showShoppersOnMap() {
      this.clearShopperMarkers();

      this.proposalList.forEach((shopper) => {
        if (!shopper.Location) return;
        let location = {
          lng: shopper.Location.Longitude,
          lat: shopper.Location.Latitude,
        };
        let infotext = `<div style="text-align: left;">
          <b>${shopper.DisplayName}</b>
          <br><b>Check ID: ${shopper.SurveyInstanceId}</b>
          <br>${this.lang.SAM005}: ${shopper.ShopperId}
          <br>${this.lang.RCM006}: ${shopper.Gender}
          <br>${this.lang.SAM009}: ${shopper.Distance} km
          <br>
          <br>${this.lang.SAM012}: ${shopper.CarSegmentName}
          <br>${this.lang.RCM016}: ${shopper.ShopperCar}
          <br>${this.lang.RCM017}: ${shopper.CarModelName} (${shopper.CarMatch})
          <br>${this.lang.A0032} ${
            shopper.MainEntityApprovalStatus ? (shopper.MainEntityApprovalStatus == 'Rejected' ? this.lang.SAM024 : this.lang.SAGM06) : this.lang.SAM023
          }
        `;
        
        infotext += `</div>`;

        const marker = new google.maps.Marker({
          position: location,
          map: this.map,
          icon: this.iconMarkerFactory(shopper.MainEntityApprovalStatus),
          infotext: infotext,
        });
        marker.addListener("click", () => {
          this.showMarkerInfo(marker);
          this.selectedMarker = marker;
          this.setMarkerOpacity(marker.SurveyInstanceId);
        });
        marker.SurveyInstanceId = shopper.SurveyInstanceId;
        this.shopperMarkers.push(marker);
      });

      this.combineMarkersWithSameLocation(this.shopperMarkers);
    },
    showMarkerInfo(marker) {
      this.map.infowindow.setContent(marker.infotext);
      this.map.infowindow.open(this.map, marker);
    },
    clearCheckMarkers() {
      this.checkMarkers.forEach((marker) => {
        marker.setMap(null);
      });
      this.checkMarkers = [];
    },
    clearShopperMarkers() {
      this.shopperMarkers.forEach((marker) => {
        marker.setMap(null);
      });
      this.shopperMarkers = [];
      this.selectedMarker = null;
    },
    combineMarkersWithSameLocation(markerList) {
      var allDuplicates= [];
      var currentDuplicates = [];
      markerList.forEach(currentMarker => {
        if(allDuplicates.filter(d => d == currentMarker).length > 0) return;

        // find markers with same position
        currentDuplicates = [];
        markerList.forEach(shopperMarker => {
          if(currentMarker === shopperMarker) return;
          if(currentMarker.position.lat() == shopperMarker.position.lat() && currentMarker.position.lng() == shopperMarker.position.lng()) {
            currentDuplicates.push(shopperMarker);
            allDuplicates.push(shopperMarker);
            markerList.filter(sm => {
              sm != shopperMarker;
            })
          }
        });
        if(currentDuplicates.length > 0) {
          currentDuplicates.push(currentMarker);
          allDuplicates.push(currentMarker);

          let infotext = ""
          let surveyInstanceIds = [];
          currentDuplicates.forEach(element => {
            surveyInstanceIds.push(element.SurveyInstanceId);
            infotext += element.infotext;
            if(element == currentDuplicates[currentDuplicates.length - 1]) return;
            infotext += "<hr>"
          });
          let location = {
            lng: currentDuplicates[0].position.lng(),
            lat: currentDuplicates[0].position.lat(),
          };
          // make new marker
          const marker = new google.maps.Marker({
            position: location,
            map: this.map,
            icon: this.iconMarkerFactory("Multiple"),
            infotext: infotext,
          });
          marker.addListener("click", () => {
            this.showMarkerInfo(marker);
            this.selectedMarker = marker;
            this.setMarkerOpacityViaArray(marker.SurveyInstanceIds);
          });
          marker.SurveyInstanceIds = surveyInstanceIds;
          markerList.push(marker);

          // delete old markers
          currentDuplicates.forEach(element => {
            element.setMap(null);
          });
        }
      });
    }
  },
};
</script>

<style>
.btn-marker-info {
  height: 26px;
  margin: 10px 0 0 0;
  padding: 0 20px 0 20px;
  box-shadow: none !important;
}
</style>

<style scoped>
#gmaps-container {
  height: calc(90vh - 80px);
  margin: 0;
  padding: 0;
}

.gmaps-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin: 5px;
  padding: 0 32px 0 10px;
  text-overflow: ellipsis;
  width: 30%;
  border: 1px solid #ccc;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  line-height: 30px;
}
.gmaps-input:focus {
  border-color: #4d90fe;
}
#gmapsRadiusInput {
  width: 120px;
}

.map-controls-container > i {
  position: absolute;
  top: 9px;
  cursor: pointer;
  border-left: 1px solid lightgray;
  padding-left: 3px;
  z-index: 10;
}
.search-icon {
  left: calc(30% - 28px);
}
.radius-icon {
  right: 10px;
  color: #bb0000;
}
.help-icon {
  top: 45px !important;
  right: 45px;
  bottom: 10px !important;
  border-left: none !important;
  color: var(--color-primary-input);
  height: 25px;
}
.tooltip-div {
  padding: 10px;
  display: flex;
}
/* img[src^='/static/pins/green_pin.png']{
  opacity: 0.5 !important
} */
</style>



// WEBPACK FOOTER //
// GoogleMaps.vue?601e23f7